module.exports = __webpack_public_path__ + "img/2.a56efab8.png";